import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MarkdownService } from '../../../../services/markdown.service';
export interface MarkdownModalData {
  markdown: string;
}

@Component({
  selector: 'app-markdown-modal',
  template: `
    <div class="markdown-modal-container">
      <div class="modal-header">
        <h2>System Prompt</h2>
        <button mat-icon-button (click)="onClose()" matTooltip="Close">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <div class="modal-content">
        <div class="markdown-body" [innerHTML]="markdownService.parse(data.markdown || '')"></div>
      </div>
    </div>
  `,
  styles: [`
    .markdown-modal-container {
      min-width: 400px;
      max-width: calc(100vw - 48px);
      padding: 0;
    }
    .modal-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0px 24px 0 24px;
    }
    .modal-content {
      padding: 24px;
      max-height: 70vh;
      overflow-y: auto;
    }
    .markdown-body {
      font-size: 15px;
    }
  `]
})
export class MarkdownModalComponent {

  constructor(
    public dialogRef: MatDialogRef<MarkdownModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MarkdownModalData,
    public markdownService: MarkdownService
  ) {
  }

  onClose(): void {
    this.dialogRef.close();
  }
} 